import { AppBar, Card, Divider, Tab, Tabs } from "@mui/material";
import { useMemo, useState } from "react";
import { useAccount, useReadContract } from "wagmi";

import AccessTimeIcon from "@mui/icons-material/AccessTime";
import VuiBox from "components/VuiBox";
import VuiButton from "components/VuiButton";
import VuiTypography from "components/VuiTypography";
import Table from "examples/Tables/Table";
import { FaExternalLinkAlt } from "react-icons/fa";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { useWallet } from "WalletProvider";
import contractABI from "../../assets/contractABI.json";

function ProfileActivitySection() {
  const [transactionsTab, setTransactionsTab] = useState(0);
  const { address } = useAccount();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [withdrawAmount, setWithdrawAmount] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [withdrawType, setWithdrawType] = useState("");
  const { wallet, selectedChain } = useWallet();

  //   const userMotherBalance = useBalance({
  //     address: wallet.address,
  //     token: motherMarket?.baseToken?.address,
  //   })
  //   console.log(userMotherBalance)

  //   const userChildBalance = useBalance({
  //     address: wallet.address,
  //     token: childMarket?.baseToken?.address,
  //   })

  // Open modal with appropriate type
  const openWithdrawModal = (type) => {
    setWithdrawType(type);

    setIsModalOpen(true);
  };

  // Handle input change
  const handleAmountChange = (e) => {
    setWithdrawAmount(e.target.value);
  };

  // Fetch all market transactions
  const {
    data: rawTxData,
    isLoading: isLoadingTx,
    isError: isErrorTx,
  } = useReadContract({
    abi: contractABI,
    address: process.env.REACT_APP_PROXY_CONTRACT_ADDRESS,
    functionName: "getMarketsByCreator",
    args: [wallet?.address],
  });

  

  // Market transactions columns
  const txColumns = [
    { name: "name", align: "left" },
    { name: "motherToken", align: "center" },
    { name: "childToken", align: "center" },
    { name: "status", align: "right" },
    { name: "createdAt", align: "right" },
  ];

  // Format market transactions for the table
  const txRows = useMemo(() => {
    if (!rawTxData) return [];

    // Sort transactions by timestamp (newest first)
    const sortedTx = [...rawTxData].sort((a, b) => Number(b.createdAt) - Number(a.createdAt));

    return sortedTx.map((tx) => ({
      name: (
        <VuiBox display="flex" alignItems="center">
          <VuiTypography variant="button" color="white" fontWeight="medium">
            {tx.name}
          </VuiTypography>
          <a
            href={`/marketdata/${tx.id}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "white", marginLeft: "5px" }}
            onClick={(e) => e.stopPropagation()}
          >
            <FaExternalLinkAlt size={12} />
          </a>
        </VuiBox>
      ),
      motherToken: (
        <VuiBox>
          <VuiTypography variant="button" color="white" fontWeight="medium">
            {tx.motherToken.slice(0, 6) + "..." + tx.motherToken.slice(-4)}
          </VuiTypography>
          {/* {tx.user.toLowerCase() === address?.toLowerCase() && (
            <VuiTypography variant="caption" color="success" fontWeight="medium" ml={1}>
              (You)
            </VuiTypography>
          )} */}
        </VuiBox>
      ),
      childToken: (
        <VuiBox display="flex" justifyContent="center">
          <VuiTypography variant="button" color="white" fontWeight="medium">
            {tx.childToken.slice(0, 6) + "..." + tx.childToken.slice(-4)}
          </VuiTypography>
          {/* {tx.user.toLowerCase() === address?.toLowerCase() && (
            <VuiTypography variant="caption" color="success" fontWeight="medium" ml={1}>
              (You)
            </VuiTypography>
          )} */}
        </VuiBox>
      ),
      status: (
        <VuiTypography variant="button" color="white" fontWeight="medium">
          {tx.status === 0
            ? "Active"
            : tx.status === 1
            ? "Merging"
            : tx.status === 2
            ? "Closed"
            : "Failed"}
        </VuiTypography>
      ),
      createdAt: (
        <VuiBox display="flex" alignItems="center" justifyContent="flex-end">
          <AccessTimeIcon fontSize="small" sx={{ mr: 0.5, opacity: 0.7 }} />
          <VuiTypography variant="caption" color="text">
            {new Date(Number(tx.createdAt) * 1000).toLocaleString()}
          </VuiTypography>
        </VuiBox>
      ),
    }));
  }, [rawTxData, address]);

  return (
    <Card
      sx={{
        mt: 3,
        background: "rgba(19, 21, 34, 0.9)",
        borderRadius: "15px",
        overflow: "hidden",
        boxShadow: "0 8px 16px rgba(0, 0, 0, 0.3)",
      }}
    >
      <AppBar position="static" sx={{ background: "transparent", boxShadow: "none" }}>
        <VuiBox display="flex" justifyContent="space-between" alignItems="center" px={2} py={1}>
          <Tabs
            value={transactionsTab}
            onChange={(e, newVal) => setTransactionsTab(newVal)}
            sx={{
              background: "transparent",
              "& .MuiTabs-indicator": {
                backgroundColor: transactionsTab === 0 ? "#1976d2" : "#2e7d32",
                height: "3px",
              },
            }}
          >
            <Tab
              label="My Markets"
              sx={{
                color: transactionsTab === 0 ? "#fff" : "rgba(255, 255, 255, 0.7)",
                fontWeight: transactionsTab === 0 ? "bold" : "normal",
              }}
            />
            {/* <Tab
              label="My Positions"
              sx={{
                color: transactionsTab === 1 ? "#fff" : "rgba(255, 255, 255, 0.7)",
                fontWeight: transactionsTab === 1 ? "bold" : "normal",
              }}
            /> */}
          </Tabs>

          {/* <Tooltip title="Refresh data">
            <IconButton
              onClick={refreshData}
              size="small"
              sx={{ color: "rgba(255, 255, 255, 0.7)" }}
            >
              <RefreshIcon />
            </IconButton>
          </Tooltip> */}
        </VuiBox>
      </AppBar>

      <Divider light sx={{ opacity: 0.2 }} />

      <VuiBox p={2}>
        {transactionsTab === 0 ? (
          <>
            <VuiBox mb={2} display="flex" justifyContent="space-between" alignItems="center">
              <VuiTypography variant="button" color="text">
                {txRows.length} total Markets
              </VuiTypography>
            </VuiBox>

            {txRows.length === 0 ? (
              <VuiBox
                textAlign="center"
                py={5}
                sx={{
                  background: "rgba(0, 0, 0, 0.2)",
                  borderRadius: "8px",
                }}
              >
                <VuiTypography variant="h6" color="text" fontWeight="regular">
                  OOps! No Markets yet
                </VuiTypography>
                <VuiButton
                  component={Link}
                  to="/market_create"
                  variant="contained"
                  color="primary"
                  sx={{ mt: 1 }}
                >
                  Connect Wallet & Create a market
                </VuiButton>
              </VuiBox>
            ) : (
              <VuiBox
                sx={{
                  "& th": {
                    borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
                      `${borderWidth[1]} solid ${grey[700]}`,
                  },
                  "& .MuiTableRow-root:not(:last-child)": {
                    "& td": {
                      borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
                        `${borderWidth[1]} solid ${grey[700]}`,
                    },
                  },
                }}
              >
                <Table columns={txColumns} rows={txRows} />
              </VuiBox>
            )}
          </>
        ) : (
          <></>
        )}
      </VuiBox>
    </Card>
  );
}

export default ProfileActivitySection;
